import React from 'react';
import { Box, StickyBottom } from 'bonfire-kindling';

const WelcomeFooter = ({ isStickyBar, stickyWidth, children }) => {
  const Component = isStickyBar ? StickyBottom : Box;

  const stickyBarProps = {
    id: 'taxonomy-codes-bottom',
    sx: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: 'auto',
      right: 0,
      py: 0,
      backgroundColor: '#FFFFFF',
      px: theme => theme.spacing(6),
    },
    tabIndex: -1,
  };

  const boxProps = {
    sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  };

  return (
    <Component {...(isStickyBar ? stickyBarProps : boxProps)}>
      {isStickyBar ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            width: '100%',
            maxWidth: stickyWidth,
          }}
        >
          {children}
        </Box>
      ) : (
        children
      )}
    </Component>
  );
};

export default WelcomeFooter;
